export const comments_3281827 = {"data":{"data":[],"links":{}}}